import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import expertCategoryQuery from './query.graphql';

const ExpertCategory = loadable(
  () => import(/* webpackChunkName: "expert" */ './expert-category'),
  {
    fallback: <Loader />,
  }
);

ExpertCategory.graphQL = expertCategoryQuery;

ExpertCategory.variables = ({ slug }) => ({
  slug,
});

export default ExpertCategory;
